






































































































































import GlobalMixin from "@/shared/mixins/globalMixin";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import CardIcon from "./CardIcon.vue";
import {
  ResultadoStatus,
  EstatisticaLeadService,
} from "@/services/estatistica-lead.service";
import moment from "moment";

@Component({
  components: { CardIcon },
})
export default class ResultadoPorStatus extends Mixins(GlobalMixin) {
  @Prop() readonly data!: string;
  dados: ResultadoStatus[] | null = null;
  loading = false;

  mounted() {
    this.fetchResultadosPorStatus();
  }

  @Watch("data")
  async fetchResultadosPorStatus() {
    this.loading = true;

    try {
      this.dados = await EstatisticaLeadService.resultadoPorStatus(
        moment(`${this.data}-01`).toDate()
      );
    } finally {
      this.loading = false;
    }
  }
}
